import React from 'react';
import { isSafeUrl } from '@atlaskit/adf-schema';
import Link from '@atlaskit/link';
import { fg } from '@atlaskit/platform-feature-flags';
import { DisplayMode } from '../../RenderForm';
import { TextfieldDisabledWrapper } from '../common/questionWrappers';
export var ViewUrlText = function ViewUrlText(_ref) {
  var value = _ref.value,
    displayMode = _ref.displayMode;
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    return /*#__PURE__*/React.createElement(TextfieldDisabledWrapper, null, /*#__PURE__*/React.createElement("div", null, value !== undefined && isSafeUrl(value) ? fg('dst-a11y__replace-anchor-with-link__jira-service-m') ? /*#__PURE__*/React.createElement(Link, {
      href: value,
      target: "_blank",
      rel: "noopener noreferrer"
    }, value) :
    /*#__PURE__*/
    // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    React.createElement("a", {
      href: value,
      target: "_blank",
      rel: "noopener noreferrer"
    }, value) : value));
  }
  return /*#__PURE__*/React.createElement("div", null, value !== undefined && isSafeUrl(value) ? fg('dst-a11y__replace-anchor-with-link__jira-service-m') ? /*#__PURE__*/React.createElement(Link, {
    href: value,
    target: "_blank",
    rel: "noopener noreferrer"
  }, value) :
  /*#__PURE__*/
  // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
  React.createElement("a", {
    href: value,
    target: "_blank",
    rel: "noopener noreferrer"
  }, value) : value);
};